

export const PROVIDERS_GET_COMPANIES = "PROVIDERS_GET_COMPANIES";
export const PROVIDERS_GET_PROJECTS = "PROVIDERS_GET_PROJECTS";
export const PROVIDERS_GET_DIMENSIONS = "PROVIDERS_GET_DIMENSIONS";
export const PROVIDERS_GET_PERIODS = "PROVIDERS_GET_PERIODS";
export const PROVIDERS_GET_STATUS = "PROVIDERS_GET_STATUS";
export const PROVIDERS_GET_ORIGINS = "PROVIDERS_GET_ORIGINS";
export const PROVIDERS_GET_PROVIDERS = "PROVIDERS_GET_PROVIDERS";
export const PROVIDERS_GET_PROVIDERS_DETAILS = "PROVIDERS_GET_PROVIDERS_DETAILS";

export const BOARD_PROCESS_STATUS = "BOARD_PROCESS_STATUS";
export const BOARD_PROCESS_EXECUTE = "BOARD_PROCESS_EXECUTE";

export const TO_PAY_PERIOD_DELAY_DATA = "TO_PAY_PERIOD_DELAY_DATA";
export const TO_PAY_PERIOD_DELAY_DETAILS_DATA = "TO_PAY_PERIOD_DELAY_DETAILS_DATA";
export const TO_PAY_PERIOD_DELAY_PROVIDERS_DATA = "TO_PAY_PERIOD_DELAY_PROVIDERS_DATA";
export const TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA = "TO_PAY_PERIOD_DELAY_PROVIDER_DETAILS_DATA";


export const PROJECTS_GET_TREE = "PROJECTS_GET_TREE";
export const PROJECTS_GET_MEANS_TREE = "PROJECTS_GET_MEANS_TREE";

export const PROJECTS_GET_DATES = "PROJECTS_GET_DATES";
export const PROJECTS_GET_SUMMARY = "PROJECTS_GET_SUMMARY";
export const PROJECTS_GET_PERIOD_GRAPH = "PROJECTS_GET_PERIOD_GRAPH";
export const PROJECTS_GET_DETAILS = "PROJECTS_GET_DETAILS";

export const PROJECTS_CLASSIFICATION_GET_SUMMARY = "PROJECTS_CLASSIFICATION_GET_SUMMARY";
export const PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH = "PROJECTS_CLASSIFICATION_GET_PERIOD_GRAPH";
export const PROJECTS_CLASSIFICATION_GET_DETAILS = "PROJECTS_CLASSIFICATION_GET_DETAILS";

export const PROJECTS_MEANS_GET_SUMMARY = "PROJECTS_MEANS_GET_SUMMARY";
export const PROJECTS_MEANS_GET_PERIOD_GRAPH = "PROJECTS_MEANS_GET_PERIOD_GRAPH";
export const PROJECTS_MEANS_GET_DETAILS = "PROJECTS_MEANS_GET_DETAILS";

export const PROJECTS_GET_TREE_PC = "PROJECTS_GET_TREE_PC";
export const PROJECTS_GET_TREE_DE = "PROJECTS_GET_TREE_DE";
export const PROJECTS_GET_TREE_FR = "PROJECTS_GET_TREE_FR";




export const PROJECTS_GET_MONTHLY_DET = "PROJECTS_GET_MONTHLY_DET";
export const PROJECTS_GET_MONTHLY_RES = "PROJECTS_GET_MONTHLY_RES";

export const PROFIT_GET_COINS = "PROFIT_GET_COINS";
export const PROFIT_GET_COMPANIES = "PROFIT_GET_COMPANIES";
export const PROFIT_GET_PROJECTS = "PROFIT_GET_PROJECTS";
export const PROFIT_GET_PERIODS = "PROFIT_GET_PERIODS";
export const PROFIT_GET_PROFIT = "PROFIT_GET_PROFIT";
export const PROFIT_GET_PC = "PROFIT_GET_PC";